//Add Email templates 

import { useMutation } from "@tanstack/react-query";
import { axiosDelete, axiosPatch } from "Redux/axiosHelper";
import { AddEmailTemplatesIntoTheClassPayload } from "types/Classes/EmailTemplates";

export async function CreateEmailTemplateForClass({ payload, classId }: { payload: AddEmailTemplatesIntoTheClassPayload; classId: string }) {
  const response = await axiosPatch(payload, `v1/edu-class/${classId}/new/add-email-template`)
  return response.data
}


export const useCreateEmailTemplateForClass = () => {
  return useMutation({
    mutationFn: CreateEmailTemplateForClass
  })
}


//Edit Email Template
export async function EditEmailTemplateInClass({ payload, classId, templateId }: { payload: AddEmailTemplatesIntoTheClassPayload; classId: string; templateId: string }) {
  const response = await axiosPatch(payload, `v1/edu-class/${classId}/new/edit-email-template/${templateId}`)
  return response.data
}


export const useEditEmailTemplateForClass = () => {
  return useMutation({
    mutationFn: EditEmailTemplateInClass,
  })
}


//Remove Email Template From Class
export async function RemoveEmailTemplateFromClass({ classId, templateId }: { classId: string; templateId: string }) {
  const response = await axiosDelete(`v1/edu-class/${classId}/new/remove-email-template/${templateId}`)
  return response.data
}


export const useRemoveEmailTemplateFromClass = () => {
  return useMutation({
    mutationFn: RemoveEmailTemplateFromClass,
  })
}

